/* eslint-disable no-console */
import {Space, Flex} from 'antd';
import React, {Fragment} from 'react';

import {monthsInFull} from '../../../constants/Common';
import {financialYear} from '../../../interface/Units';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import {formatIndian} from '../../../utils/formatIndian';
import PilComp from '../../DisplayComponent/PilComp';
import {WasteKey} from '../../Forms/Constants/IP/WasteKeyLabel';
import sumValue from '../../Table/Utils/sumValue';
import {renderTimeframeDataUnit} from '../commonFunctions';

const TimeFrameRender: React.FC<{
  value: any;
  label: string;
  isChecker?: boolean;
}> = ({value, label, isChecker = false}) => {
  const color = '#d3eec6';
  const companyDetails = useCompanyStore.getState().companyDetails;
  const fiscalYear: financialYear = companyDetails.fiscalYear;

  return (
    <div>
      {value?.map((timeFrame: any, index: number) => {
        return (
          <Fragment key={index}>
            {!isChecker && (
              <div className="formProperty" style={{padding: '12px 0 8px 0px'}}>
                {timeFrame?.type === WasteKey.notTreated.wasteNotTreated
                  ? ''
                  : Array.isArray(label)
                    ? `${label?.[index]} (${timeFrame?.unit}) : `
                    : `${label} (${timeFrame?.unit}) : `}
              </div>
            )}
            <div className="formOutput" style={{padding: '8px 0 8px 0px'}}>
              {timeFrame?.timeFrame === 'monthly' ? (
                <Space size={[8, 16]} wrap>
                  {isChecker ? (
                    <div>
                      {`${renderTimeframeDataUnit(
                        formatIndian(sumValue(timeFrame?.data)),
                        timeFrame?.unit
                      )} (${Array.isArray(label) ? label?.[index] : label})`}
                    </div>
                  ) : (
                    timeFrame?.data?.map((item: any, i: number) => {
                      return (
                        <PilComp
                          value={`${monthsInFull[fiscalYear][i]} - ${
                            item?.value ? formatIndian(item?.value) : 'NA'
                          }`}
                          color={color}
                          style={{
                            textAlign: 'center',
                            padding: '4px 10px'
                          }}
                          key={i}
                        />
                      );
                    })
                  )}
                </Space>
              ) : (
                // <Row gutter={[8, 8]}>
                //   {isChecker ? (
                //     <Col span={24}>{`${sumValue(timeFrame?.data)} ${
                //       timeFrame?.unit ? timeFrame?.unit : ''
                //     } (${Array.isArray(label) ? label?.[index] : label})`}</Col>
                //   ) : (
                //     timeFrame?.data?.map((item: any, i: number) => {
                //       return (
                //         <Col span={6} key={i}>
                //           <PilComp
                //             value={`${monthsInFull[fiscalYear][i]} - ${
                //               item?.value ? formatIndian(item.?value) : 'NA'
                //             }`}
                //             color={color}
                //             style={{
                //               padding: '10px 20px',
                //               width: '100px',
                //               height: '20px',
                //               textAlign: 'center'
                //             }}
                //           />
                //         </Col>
                //       );
                //     })
                //   )}
                // </Row>
                timeFrame?.data?.map((mainData: any, i: number) => {
                  return (
                    i === 0 && (
                      <Flex key={i}>
                        {isChecker ? (
                          <div>
                            {`${renderTimeframeDataUnit(
                              formatIndian(mainData?.value),
                              timeFrame?.unit
                            )} (${
                              Array.isArray(label) ? label?.[index] : label
                            })`}
                          </div>
                        ) : (
                          <PilComp
                            value={`Yearly - ${
                              mainData.value
                                ? formatIndian(mainData?.value)
                                : 'NA'
                            }`}
                            color={color}
                            style={{
                              padding: '10px 20px'
                            }}
                          />
                        )}
                      </Flex>
                    )
                  );
                })
              )}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};

export default TimeFrameRender;
